import InfoTooltip from 'components/InfoTooltip';
import CheckboxInput from 'components/forms/inputs/rhf-inputs/CheckboxInput';
import MultiSelectInput from 'components/forms/inputs/rhf-inputs/MultiSelectInput';
import SelectInput from 'components/forms/inputs/rhf-inputs/SelectInput';
import TextAreaInput from 'components/forms/inputs/rhf-inputs/TextAreaInput';
import TextInput from 'components/forms/inputs/rhf-inputs/TextInput';
import { getValidOptionsFromClassifier } from 'utils/formUtil';
import { TaskFormState } from './useTaskForm';

/** General: the task's types, name, description and priority. */
export const GeneralFields = ({ form }: { form: TaskFormState }): JSX.Element => {
    const { control, setValue } = form.methods;
    const { classifiers, handleOnTaskTypesChange } = form;

    return (
        <>
            <MultiSelectInput
                setValue={setValue}
                control={control}
                label="tasks.form.task-type"
                placeholder="tasks.form.task-type"
                name="taskTypes"
                options={
                    (getValidOptionsFromClassifier(classifiers['TASK_TYPE']) as {
                        label: string;
                        value: string;
                    }[]) ?? []
                }
                onChange={handleOnTaskTypesChange}
                getOptionLabel="label"
                getOptionIdentifier="value"
                required
            />
            <TextInput
                name="name"
                control={control}
                label="tasks.form.task-name"
                placeholder="tasks.form.task-name"
                required
            />
            <TextAreaInput
                control={control}
                label="tasks.form.description"
                placeholder="tasks.form.description"
                name="description"
            />
            <SelectInput
                setValue={setValue}
                control={control}
                label="tasks.form.priority"
                placeholder="tasks.form.priority"
                name="taskPriority"
                options={
                    (getValidOptionsFromClassifier(classifiers['TASK_PRIORITY_TYPE']) as {
                        label: string;
                        value: string;
                    }[]) ?? []
                }
                getOptionLabel="label"
                getOptionIdentifier="value"
                required
            />
        </>
    );
};

/** General, continued: whether the task is official, and its official reference. */
export const OfficialFields = ({ form }: { form: TaskFormState }): JSX.Element => {
    const { control } = form.methods;
    const { isOfficial, handleIsOfficialToggle } = form;

    return (
        <>
            <CheckboxInput
                control={control}
                name="isOfficial"
                label="official"
                rightLabelComponent={<InfoTooltip text="tasks.tooltips.official" />}
                onChange={handleIsOfficialToggle}
            />
            {isOfficial ? (
                <TextInput
                    control={control}
                    name="officialReference"
                    label="official-reference-number"
                    placeholder="correspondence.enter-official-reference-number"
                    tooltip={<InfoTooltip text="tasks.tooltips.official-reference-number" />}
                />
            ) : null}
        </>
    );
};
